import "./index.less";
import * as React from "react";
import { Collapse } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PrintModeEnum } from "@atman/business";
import { action, observable, reaction } from "mobx";
import { inject, observer } from "mobx-react";

export interface ICollapsableCardProps {
    title?: string;
    titleSize?: "sm" | "md";
    cardContent: React.ReactNode;
    customLeftHeaderContent?: React.ReactNode;
    customRightHeaderContent?: React.ReactNode;
    defaultCollapseOpenState?: boolean;
    className?: string;
    id?: string;
    printMode?: PrintModeEnum;
    isCollapseOpen?: boolean;
    toggleCollapse?: () => void;
    disabled?: boolean;
}

@inject()
@observer
export class CollapsableCard extends React.Component<ICollapsableCardProps, {}> {
    @observable public isCollapseOpen: boolean = this.props.defaultCollapseOpenState ?? false;

    defaultCollapseOpenStateReactionDisposer = reaction(
        () => this.props.defaultCollapseOpenState,
        () => (this.isCollapseOpen = this.props.defaultCollapseOpenState ?? false),
    );

    componentWillUnmount(): void {
        this.defaultCollapseOpenStateReactionDisposer();
    }

    @action.bound toggleCollapse = () => {
        const { toggleCollapse, disabled } = this.props;

        if (disabled) {
            return;
        }

        if (toggleCollapse) {
            toggleCollapse();
            return;
        }

        this.isCollapseOpen = !this.isCollapseOpen;
    };

    render() {
        const {
            title,
            titleSize,
            cardContent,
            customLeftHeaderContent,
            customRightHeaderContent,
            className,
            id,
            printMode,
            isCollapseOpen,
            disabled,
        } = this.props;

        let additionalClasses: string = "";
        if (printMode === PrintModeEnum.Detailed) {
            additionalClasses = "detailed";
        }

        const isOpen = isCollapseOpen ?? this.isCollapseOpen;

        return (
            <div
                className={`CollapsableCard ${className ?? ""} ${
                    isOpen ? "is-open" : "is-closed"
                } ${additionalClasses}`}
                id={id}
            >
                <div className={`header ${disabled ? "disabled" : ""}`} onClick={this.toggleCollapse}>
                    <div className="left-section">
                        <FontAwesomeIcon icon={["far", isOpen ? "chevron-up" : "chevron-down"]} />
                        {customLeftHeaderContent ? (
                            customLeftHeaderContent
                        ) : titleSize === "sm" ? (
                            <h4>{title}</h4>
                        ) : (
                            <h3>{title}</h3>
                        )}
                    </div>
                    {customRightHeaderContent && (
                        <div className="right-section" onClick={(e) => e.stopPropagation()}>
                            {customRightHeaderContent}
                        </div>
                    )}
                </div>
                <Collapse isOpen={isOpen}>
                    <div className="content">{cardContent}</div>
                </Collapse>
            </div>
        );
    }
}
